<template>
  <section class="section">
    <div class="container has-text-centered">
      <h1 class="main-title title">
        Advanced speaking, listening and spelling practice
      </h1>
      <p class="subtitle">in {{ languageList }}</p>
      <b-button tag="router-link" to="/library" type="is-info" size="is-medium">
        <span class="has-text-weight-bold">Explore the library</span>
      </b-button>
      <br />
      <br />
      <br />
      <div class="columns is-vcentered">
        <div class="column">
          <figure class="factory">
            <img src="@/assets/bubble-paragraphs.webp" alt="Factory" />
          </figure>
        </div>
        <div class="column">
          <p class="is-size-3 is-size-4-touch">
            Text synced audio paragraphs read by native speakers
          </p>
          <div class="columns is-mobile is-multiline stats">
            <div class="column is-6">
              <div class="stat">
                <p class="heading is-size-6 is-size-7-touch">Books</p>
                <p class="title is-size-2 is-size-3-touch">{{ books }}</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="stat">
                <p class="heading is-size-6 is-size-7-touch">Languages</p>
                <p class="title is-size-2 is-size-3-touch">{{ languages }}</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="stat">
                <p class="heading is-size-6 is-size-7-touch">Paragraphs</p>
                <p class="title is-size-2 is-size-3-touch">{{ paragraphs }}</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="stat">
                <p class="heading is-size-6 is-size-7-touch">Minutes</p>
                <p class="title is-size-2 is-size-3-touch">{{ minutes }}</p>
              </div>
            </div>
          </div>
          <b-button
            tag="router-link"
            to="/library"
            type="is-info"
            size="is-medium"
          >
            <span class="has-text-weight-bold">Explore the library</span>
          </b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["languageList", "books", "paragraphs", "minutes", "languages"]
};
</script>

<style lang="scss" scoped>
.stats {
  padding-top: 60px;
  padding-bottom: 60px;
}

.stat {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
